<template src="./RegisterPlanService.html" />

<script>
import { computed } from "vue"
import { useStore } from "@/store/store.js"
import mixins from "@/Mixins.js"

export default {
  name: "registerPlanService",
  mixins: [mixins],
  data() {
    return {
      planServices: [],
      planServicesFiltered: [],
      serviceFilter: "",
      defaultTableText: "Aguarde, estamos carregando as informações...",
      service: {
        id: null,
        active: true,
        name: "",
        partner: "",
        description: "",
      },
      invalid: {
        serviceName: false,
        serviceDescription: false,
      },
      modalTitle: "",
      currentx: 1,
      perPage: 10,
      searchTimeOut: null,
    }
  },

  setup () {
    const store = useStore()

    return {
      isMobile: computed(() => store.getters.isMobile),
      getPlanServicesList: () => store.dispatch("getPlanServices"),
      getPlanServiceById: (id) => store.dispatch("getPlanServiceById", id),
      createPlanService: (payload) => store.dispatch("createPlanService", payload),
      updatePlanService: (payload) => store.dispatch("updatePlanService", payload),
    }
  },

  computed: {
    isPaginated() {
      return this.numPages > 1
    },
    numPages() {
      return Math.ceil(this.planServicesFiltered.length / this.perPage)
    },
    planServicesPaginated() {
      const start = (this.currentx - 1) * this.perPage
      const end = start + this.perPage

      return this.planServicesFiltered.slice(start, end)
    },
  },

  mounted () {
    this.getPlanServices()
  },

  watch: {
    serviceFilter (val) {
      clearTimeout(this.searchTimeOut)

      this.searchTimeOut = setTimeout(() => {
        this.planServicesFiltered = val
          ? this.planServices.filter(
            (serv) => serv.name.toLowerCase().includes(val.toLowerCase())
          )
          : this.planServices
      }, 500)
    },
  },
  methods: {
    async getPlanServices() {
      const response = await this.getPlanServicesList()

      if (response) {
        this.defaultTableText = "Nenhum resultado encontrado"

        if (response.length > 0) {
          this.currentx = 1
          this.planServices = response
          this.planServicesFiltered = this.planServices
        }
      } else {
        this.showNotifyWarning(
          "Ocorreu um erro ao buscar a lista de Serviço de planos. Por favor, tente novamente mais tarde!",
          5000,
        )
      }
    },
    async handleEdit(id) {
      const response = await this.getPlanServiceById(id)

      if (response) {
        this.modalTitle = "Editar serviço"
        this.$bvModal.show("modal-register-new-service")

        this.service = response
      } else {
        this.showNotifyWarning(
          "Ocorreu um erro ao tentar selecionar o serviço. Por favor, tente novamente mais tarde!",
          5000,
        )
      }
    },
    handleNewService() {
      this.service = {}
      this.modalTitle = "Novo serviço"
      this.$bvModal.show("modal-register-new-service")
    },
    async handleToggleStatus(id) {
      this.service = this.planServices.find((service) => service.id === id)
      this.service.active = !this.service.active

      this.savePlanService()
    },
    async savePlanService() {
      if (!this.service.name) {
        this.invalid.serviceName = true
      }

      if (!this.service.description) {
        this.invalid.serviceDescription = true
      }

      if (!Object.values(this.invalid).some((val) => val)) {
        this.$vs.loading()

        const payload = {
          active: this.service.id ? this.service.active : true,
          name: this.service.name,
          partner: this.service.partner,
          description: this.service.description,
        }

        const response = this.service.id
          ? await this.updatePlanService({ id: this.service.id, payload })
          : await this.createPlanService(payload)

        if (response && response.success) {
          await this.getPlanServices()

          this.$bvModal.hide("modal-register-new-service")
          this.$bvModal.show("confirm-success-modal")
        }

         this.$vs.loading.close()
      }
    },
    handleConfirmation() {
      this.$bvModal.hide("confirm-success-modal")

    }
  },
}
</script>

<style lang="scss" src="./RegisterPlanService.scss" scoped />
